import { Component } from '@angular/core';
import { BaseComponent } from '../../../shared/base-classes/base.component';
import { AppToastManagerService } from '../../../shared/services/toast-manager.service';
import { AppBellSchedulesService } from '../bell-schedules.service';
import {
  BellScheduleResponseDto,
  PaginationResultsDto,
} from '@whetstoneeducation/hero-common';
import { ITableFilters } from '../../../shared/tables/table-filters/table-filters.interface';
import { TableFilterOptions } from '../../../shared/tables/table-filters/table-filters';
import { TableFiltersPageKeyEnum } from '../../../shared/tables/table-filters/table-filters-page-key.enum';
import { logger } from '../../../shared/logger';
import { ActivatedRoute } from '@angular/router';
import { IBellScedulesListFilters } from '../bell-schedules-models/bell-schedules-filters.interface';

@Component({
  selector: 'app-bell-schedules-list',
  templateUrl: 'bell-schedules-list.template.html',
  styleUrls: ['./bell-schedules-list.scss'],
})
export class AppBellSchedulesListComponent extends BaseComponent {
  public bellSchedules: BellScheduleResponseDto[];
  public hasSelectedSchool: boolean;
  private schoolId: number;
  public filters: IBellScedulesListFilters;

  constructor(
    public route: ActivatedRoute,
    private toastService: AppToastManagerService,
    private bellSchedulesService: AppBellSchedulesService
  ) {
    super();
    this.loadData();
  }

  public loadData(): void {
    this.isLoading = true;
    const data = this.route.snapshot.data
      .data as PaginationResultsDto<BellScheduleResponseDto>;
    this.bellSchedules = data.results;
    this.schoolId = this.StorageManager.getLoggedInUser().currentSchoolId;
    this.hasSelectedSchool = !!this.schoolId;
    this.filters = { inactive: false} as IBellScedulesListFilters;
    this.filters.tableFilters = TableFilterOptions.getPageDefault(
      TableFiltersPageKeyEnum.BELL_SCHEDULES_LIST
    );
    this.filters.tableFilters.count = data.options?.totalItems;
    this.isLoading = false;
  }

  public async updateTableFilters(
    newTableFilters: ITableFilters
  ): Promise<void> {
    this.isLoading = true;
    this.filters.tableFilters = newTableFilters;
    await this.updateBellSchedulesList(this.filters);
    this.isLoading = false;
  }

  public async updateBellSchedulesList(filters: IBellScedulesListFilters): Promise<void> {
    try {
      const newData = await this.bellSchedulesService.getBellSchedulesList(
        this.schoolId,
        this.filters
      );
      this.bellSchedules = newData.results;
      this.filters.tableFilters.count = newData.options?.totalItems;
    } catch (err) {
      this.toastService.error('Error retrieving bell schedules!');
      logger.error(err);
    }
  }

  public async updateFilters(newFilters: IBellScedulesListFilters): Promise<void> {
      this.isLoading = true;
      this.filters = newFilters;
      this.filters.tableFilters = TableFilterOptions.resetTableFilters(
        TableFiltersPageKeyEnum.BELL_SCHEDULES_LIST,
        this.filters.tableFilters
      );
      await this.updateBellSchedulesList(this.filters);
      this.isLoading = false;
    }
}
